import React from "react";
import { useParams } from "react-router-dom";

import ScrollToTop from "../../../components/utils/ScrollToTop";
import { getFormattedDate } from "../../../utils/textUtils";
import { sanitiseHtml } from "../../../utils/sanitiseHtml";
import { useMarkNotificationRead } from "../Notification";
import { useSelectedCase } from "../utils/hooks";
import ProbatePage from "./ProbatePage";
import { MessageBody } from "./Sheet";

const ProbateMessage = () => {
  const { notificationId } = useParams();
  const selectedCase = useSelectedCase({ caseScreen: "notification" });
  const notification = selectedCase?.notifications?.find((n) => n.id === notificationId);

  useMarkNotificationRead(selectedCase, notification);

  if (!notification) return null;

  return (
    <ProbatePage
      caseRef={selectedCase.case_reference}
      title={notification.subject}
      details={getFormattedDate(notification.created_at)}
      back={{ to: `/dashboard/${selectedCase.case_reference}/messages`, label: "Messages" }}
    >
      <ScrollToTop />
      <MessageBody dangerouslySetInnerHTML={{ __html: sanitiseHtml(notification.content) }} />
    </ProbatePage>
  );
};

export default ProbateMessage;
